import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import pluralize from "pluralize";
import { colors, fonts } from "../../../styles/variables";

import checkIcon from "../../../assets/images/icons/check.svg";
import badgeDefault from "../../../assets/images/icons/badge-default.svg";

const StyledBadgeItem = styled.div`
  display: inline-block;
  max-width: 80px;
  text-align: center;
  cursor: pointer;
  position: relative;
`;

const BadgeItemImageHolder = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  background-color: ${(props) => (props.isEarned ? colors.blue : colors.silverSoft)};
  margin: auto;
  margin-bottom: ${(props) => (props.shouldShowBadgeStatusIcon ? "0px" : "10px")};
`;

const BadgeItemImage = styled.img`
  max-width: 100%;
  ${(props) =>
    !props.isEarned &&
    css`
      filter: grayscale(100%);
    `}
`;

const BadgeItemTitle = styled.h5`
  font-size: 10px;
  white-space: normal;
  font-family: ${fonts.fontInterstateUltraBlack};
  text-transform: uppercase;
  line-height: 0.9;
  margin-bottom: 0;
`;

const BadgeItemPoint = styled.p`
  font-size: 12px;
`;

const BadgeIconContainer = styled.div`
  opacity: ${(props) => (props.isEarned ? 1 : 0)};
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: initial;
`;

const BadgeIcon = styled.img`
  height: 10px;
  width: 10px;
`;

const BadgeItem = ({
  imageUrl,
  title,
  level,
  point = 0,
  isEarned,
  className = "",
  onClick,
  showLevel = false,
  showPointsOrWineLevel = true,
  shouldShowBadgeStatusIcon = false,
}) => {
  const hasLevel = !!level;
  const levelText = `Level ${level || 1}`;
  const levelDescription = level !== null ? levelText : title;

  return (
    <StyledBadgeItem className={className} onClick={onClick} title={levelDescription}>
      <BadgeItemImageHolder isEarned={!!isEarned} shouldShowBadgeStatusIcon={shouldShowBadgeStatusIcon}>
        <BadgeItemImage isEarned={!!isEarned} src={imageUrl || badgeDefault} />
      </BadgeItemImageHolder>
      {shouldShowBadgeStatusIcon && (
        <BadgeIconContainer isEarned={!!isEarned}>
          <BadgeIcon src={checkIcon} alt="Check Icon" />
        </BadgeIconContainer>
      )}
      <BadgeItemTitle>{title || ""}</BadgeItemTitle>
      {showLevel && hasLevel && <BadgeItemTitle>{levelText}</BadgeItemTitle>}
      <BadgeItemPoint>
        {showPointsOrWineLevel && <> {point > 0 ? pluralize("point", point, true) : "wine level"} </>}
      </BadgeItemPoint>
    </StyledBadgeItem>
  );
};

BadgeItem.propTypes = {
  imageUrl: PropTypes.string,
  title: PropTypes.string,
  point: PropTypes.number,
  level: PropTypes.number,
  isEarned: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func,
  showLevel: PropTypes.bool,
  showPointsOrWineLevel: PropTypes.bool,
  shouldShowBadgeStatusIcon: PropTypes.bool,
};

export default BadgeItem;
